import axios, { AxiosResponse } from 'axios'
import UserService from '../UserService'

const apiUrl = import.meta.env.VITE_API_URL

const userToken = UserService.getToken() ?? '' 

export const clientHost = apiUrl === "https://api.vivamoveis.dev.br/vm-api/" ? "https://plataforma.vivamoveis.dev.br" : "https://cliente.vivamoveis.com.br"
export const api = axios.create({
  baseURL: apiUrl ?? `http://localhost:3333/vm-api`,
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${userToken}`,
  },
})

api.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    console.log('Erro na requisição: ', error)

    const data = error.response?.data ?? { message: 'Erro na requisição' }

    const response: AxiosResponse<any, any> = {
      data: data,
      status: error.response.status ?? 500,
      statusText: 'Erro na requisição',
      headers: {},
      config: error.config,
      request: error.request,
    }

    if (error.response.status === 401) {
      UserService.logout()
      window.location.href = '/'
    }

    return Promise.reject(response)
  }
)
